<template>
    <div>
        <ubi-panel>
            <ubi-form-group :title="$t('posts.interiorTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.surface_habitable"
                                      prop="surface_habitable"
                        >
                            <el-input step="0.01" v-model="post.surface_habitable"
                                      type="number">
                                <div slot="append">m²</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.surface_carrez"
                                      prop="surface_carrez"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.surface_carrez"
                                      type="surface_carrez">
                                <div slot="append">m²</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.nombre_etages"
                                      prop="nombre_etages"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.nombre_etages"
                                      type="nombre_etages">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.nb_bien"
                                      prop="nb_bien"
                        >
                            <el-input v-mask="'#################'" v-model.number="post.nb_bien" type="nb_bien">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.ascenseur">
                            <el-radio v-model="post.ascenseur" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.ascenseur" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.acces_internet_haut_debit">
                            <el-radio v-model="post.acces_internet_haut_debit" label="oui">{{ $t("general.yes") }}
                            </el-radio>
                            <el-radio v-model="post.acces_internet_haut_debit" label="non">{{ $t("general.no") }}
                            </el-radio>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>
        <dpe-ges :post="post"></dpe-ges>
        <isolation-thermique-solaire :post="post"></isolation-thermique-solaire>
        <securite-bien :post="post"></securite-bien>

    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import DpeGes from '../Block/DpeGes'
import IsolationThermiqueSolaire from '../Block/IsolationThermiqueSolaire'
import SecuriteBien from "@/pages/posts/forms/Block/SecuriteBien.vue";

export default {
  name: 'PostEditImmoObject1500',
  props: ['post', 'ddList'],
  components: {SecuriteBien, DpeGes, IsolationThermiqueSolaire },
  data () {
    return {}
  },
  computed: {},
  methods: {},
  async beforeMount () {
    let codes = ['dpe_etiquette_conso', 'dpe_etiquette_ges', 'modalites_recuperation_charges_locatives', 'mandat_statut']

    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type == 'error') {
      // this.$message({message: this.$t("error.found"), type: 'error'});
      this.loading = false
      return false
    }
    this.$emit('ddList-update', definitionDonneeListeeByCode)
  }
}
</script>
